import {
    Redirect,
    Stack,
    useFocusEffect,
    useLocalSearchParams,
} from 'expo-router';
import { useSetAtom } from 'jotai';
import { useCallback, useEffect } from 'react';

import { selectedMembershipIdAtom } from '../../../entities/entityAtoms';
import { MoneyMapperPage } from '../../../money-map/components/MoneyMapperPage';
import { MoneyMapAccountsProvider } from '../../../money-map/providers/MoneyMapAccountsProvider';

const MoneyMapperScreen = () => {
    const { membershipId, moneyMapId } = useLocalSearchParams<{
        membershipId: string;
        moneyMapId: string;
    }>();
    const setSelectedMembershipId = useSetAtom(selectedMembershipIdAtom);

    // This effect will only run once per membership because each membership details page
    // is rendered separately in a navigation stack (thus, going back to previously viewed
    // memberships is fast)
    useEffect(() => {
        if (membershipId) {
            setSelectedMembershipId(membershipId);
        }
    }, [membershipId, setSelectedMembershipId]);

    // This effect will run every time a membership is re-visited
    // so if the data fetch for this membership wasn't completed on the first visit,
    // this will trigger a new request for the data
    useFocusEffect(
        useCallback(() => {
            if (membershipId) {
                setSelectedMembershipId(membershipId);
            }
        }, [membershipId, setSelectedMembershipId]),
    );

    // Should not happen.
    if (membershipId == null) {
        return <Redirect href="/" />;
    }

    // Should not happen.
    if (moneyMapId == null) {
        return <Redirect href={`/membership/${membershipId}`} />;
    }

    return (
        <>
            <Stack.Screen options={{ headerShown: false }} />
            <MoneyMapAccountsProvider>
                <MoneyMapperPage moneyMapId={moneyMapId} />
            </MoneyMapAccountsProvider>
        </>
    );
};

export default MoneyMapperScreen;
